import React from 'react';
import { get, omit } from 'lodash-es';
import Button from 'reactstrap/lib/Button';
import { VehicleEntities } from 'client/data/models/vehicle-v2';
import { PhotoflipperButtonAsync } from 'site-modules/shared/components/photoflipper-core/photoflipper-button/photoflipper-button-async';
import { VehicleImage } from 'site-modules/shared/components/vehicle-image/vehicle-image';
import { getS3MediaDefaultImageUrlBySize } from 'client/utils/image-helpers';

import './model-overview.scss';

const IMAGE_WIDTH = 300;
const IMAGE_HEIGHT = 200;

export function ModelOverview({ vehicle }) {
  const makeName = get(vehicle, 'make.name', '');
  const modelName = get(vehicle, 'model.name', '');
  const makeSlug = get(vehicle, 'make.slug', '');
  const modelSlug = get(vehicle, 'model.slug', '');
  const year = get(vehicle, 'year', '');
  const src = getS3MediaDefaultImageUrlBySize(omit(vehicle, 'submodels'), IMAGE_WIDTH, IMAGE_HEIGHT);
  const vehicleObj = {
    makeName,
    modelName,
    year,
  };

  return (
    <div className="pos-r model-overview">
      <PhotoflipperButtonAsync makeSlug={makeSlug} modelSlug={modelSlug} year={year}>
        <div className="model-overview-photoflipper d-flex flex-column">
          <div className="img-wrapper">
            <VehicleImage vehicle={vehicleObj} src={src} imgClasses="rounded model-overview-photo" />
          </div>
          <Button color="link" size="lg" className="view-photos py-0_5 px-0 text-start text-primary-darker">
            Photos & videos
          </Button>
        </div>
      </PhotoflipperButtonAsync>
    </div>
  );
}

ModelOverview.propTypes = {
  vehicle: VehicleEntities.MakeModelSubmodelYear.isRequired,
};
